// extracted by mini-css-extract-plugin
export default {"dataPoint":"_29dyF___DataPoint-module__dataPoint","dataPointLabel":"_2_p0u___DataPoint-module__dataPointLabel","dataPointValue":"_1Zv7d___DataPoint-module__dataPointValue"};